import { FunctionComponent } from 'react';

export interface ButtonProps {
  text: string;
  type?: 'button' | 'submit' | 'reset';
  isSecondary?: boolean;
  onClick?: () => void;
}

const Button: FunctionComponent<ButtonProps> = ({
  text,
  type = 'button',
  onClick,
  isSecondary,
}) => {
  return (
    <>
      {!isSecondary ? (
        <button
          className={'bg-blue-600 py-2 px-6 m-3 rounded w-auto text-white'}
          type={type}
          onClick={onClick}
        >
          {text}
        </button>
      ) : (
        <button
          className={
            ' bg-white py-2 px-6 m-3 rounded w-auto text-blue-600 border-blue-600 border-2'
          }
          type={type}
          onClick={onClick}
        >
          {text}
        </button>
      )}
    </>
  );
};

export default Button;
